import { FormControl, Grid, MenuItem, Pagination, Select, TableFooter, Typography } from "@mui/material";
import React from "react";

export default function TablePaginationShowPage({ rowsPerPageOptions, colSpan, count, rowsPerPage, page, onPageChange, onRowsPerPageChange }) {
    return (
        <TableFooter
            sx={{
                display: "flex",
                alignItems: "center",
                gap: "20px",
                justifyContent: "space-between",
            }}
        >
            <Grid display="flex" gap={2} alignItems="center">
                <Typography variant="body2">Rows per page:</Typography>
                <FormControl>
                    <Select
                        id="row-per-page-component"
                        value={rowsPerPage}
                        onChange={onRowsPerPageChange}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    boxShadow: "rgba(0, 0, 0, 0.1) 0px 15px 15px 2px, rgba(0, 0, 0, 0.1) 0px 4px 6px -4px",
                                },
                            },
                        }}
                        sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            borderRadius: "8px",
                            width: "70px",
                        }}
                        size="small"
                    >
                        {rowsPerPageOptions.map((value, index) => (
                            <MenuItem key={index} value={value}>
                                {value}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Pagination
                count={Math.ceil(count / rowsPerPage)}
                page={page + 1}
                size="medium"
                color="primary"
                onChange={(e, pages) => onPageChange(e, pages - 1)}
            />
        </TableFooter>
    );
}
